import { ok, err, Result } from '../../../tracking-api';
import { CMIElement, CMIErrorCode, Scorm2004Api, ScormError } from '../api';
import { Scorm2004ApiLogDecorator } from './scorm2004-api-log-decorator';
//import { reportNonFatalError } from '@/app/error-handling';

export class Scorm2004Client {

  private api: Scorm2004Api;

  constructor(api: Scorm2004Api) {
    this.api = new Scorm2004ApiLogDecorator(api);
  }

  public initialize() {
    const result = this.withErrorChecking(() => this.api.Initialize(''));
    // if (!result.success) {
    //   reportNonFatalError(`initialize error`, result.error)
    // }

    return result
  }

  public setValue(element: CMIElement, value: string) {
    const result = this.withErrorChecking(
      () => this.api.SetValue(element, value));

    // if (!result.success) {
    //   reportNonFatalError(`setValue error, element: '${element}', value: '${value}'`, result.error)
    // }

    return result
  }

  public setValues(items: Array<[ string, any ]>) {
      for (const item of items) {
        const setResult = this.setValue(item[0],
                                        item[1].toString());
        if (!setResult.success) {
          // reportNonFatalError(`setValue error, element: '${item[0]}', value: '${item[1]}'`, setResult.error)
          return err(setResult.error);
        }
      }
  }

  public getValue(element: CMIElement) {
    const result = this.withErrorChecking(
      () => this.api.GetValue(element));

    // if (!result.success) {
    //   reportNonFatalError(`getValue error, element: '${element}'`, result.error)
    // }

    return result
  }

  public commit() {
    const result = this.withErrorChecking(() => this.api.Commit(''));
    // if (!result.success) {
    //   reportNonFatalError(`commit error`, result.error)
    // }

    return result
  }

  public terminate() {
    const result = this.withErrorChecking(() => this.api.Terminate(''));
    // if (!result.success) {
    //   reportNonFatalError(`terminate error`, result.error)
    // }
    return result
  }

  private withErrorChecking<TResult>(func: () => TResult): Result<TResult, ScormError> {

    const value = func();

    const errorCode = this.api.GetLastError();
    if (errorCode !== '0') {
      const parsedErrorCode = this.parseErrorCode(errorCode);
      const message = this.api.GetErrorString(errorCode);
      const diagnostic = this.api.GetDiagnostic(errorCode);

      return err(new ScormError(parsedErrorCode, message, diagnostic));
    }

    return ok(value);
  }

  private parseErrorCode(codeString: string): CMIErrorCode {
    return codeString as CMIErrorCode;
  }
}
